/**
 * Brand tokens from https://www.astromania.in/ (style.css .bg1 / .bg2 / .clr2).
 * Used for seed defaults and LMS chrome alignment.
 */
export const ASTROMANIA_BRAND = {
  purple: "#3c154e",
  purpleDeep: "#2a0e38",
  orange: "#ff6600",
  orangeHover: "#e65c00",
  cream: "#faf7f5",
  ink: "#1a1220",
  tagline: "Your Professional Destiny",
  /** Official Astromania wordmark (white) for purple/black chrome */
  logoPath: "/brand/astromania-logo.png",
  siteUrl: "https://www.astromania.in",
  about:
    "Astromania has been serving its valuable expertise and insights in the arena of astrology for more than two decades now. Astromania has been marking an incredible journey with a commitment to excellence for probing the interrelations between cosmical phenomena and human fortunes.",
  address:
    "Regus, 7th Floor, Tower A Plot No.4B, District Centre, Mayur Vihar Phase-1, Delhi-110091",
  phones: ["+91 9319899263", "+91 9560618116"],
  email: "info@astromania.co.in",
  social: {
    facebook: "https://www.facebook.com/astromania.in",
    instagram: "https://www.instagram.com/astromania_in",
    youtube: "https://www.youtube.com/@astroankitagnihotri",
  },
  legal: {
    privacy: "https://www.astromania.in/privacy-policy",
    terms: "https://www.astromania.in/terms-and-conditions",
    refund: "https://www.astromania.in/refund-policy",
  },
} as const;

export function astromaniaSeedBranding(): {
  branding: { accentColor: string };
  aiTutorPersonaName: { en: string; hi: string };
} {
  return {
    branding: {
      accentColor: ASTROMANIA_BRAND.orange,
    },
    // MT-1 TEN-007: the tutor's persona is Astromania's data (0018_mt1_astromania_persona).
    aiTutorPersonaName: { en: "Ankit Sir", hi: "आंकित सर" },
  };
}

export function astromaniaFooterContact() {
  return {
    address: ASTROMANIA_BRAND.address,
    phones: [...ASTROMANIA_BRAND.phones],
    email: ASTROMANIA_BRAND.email,
    social: { ...ASTROMANIA_BRAND.social },
    legal: { ...ASTROMANIA_BRAND.legal },
    logoPath: ASTROMANIA_BRAND.logoPath,
    siteUrl: ASTROMANIA_BRAND.siteUrl,
  };
}
